import { render, staticRenderFns } from "./myCert.vue?vue&type=template&id=4a393188&scoped=true&"
import script from "./myCert.vue?vue&type=script&lang=js&"
export * from "./myCert.vue?vue&type=script&lang=js&"
import style0 from "./myCert.vue?vue&type=style&index=0&lang=less&"
import style1 from "./myCert.vue?vue&type=style&index=1&id=4a393188&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a393188",
  null
  
)

export default component.exports